import { ILocation } from '../interfaces/iLocation'

export class Location implements ILocation {
    public key: string;
    public orgKey: string;
    public cityKey: string;
    public city: string;
    public type: string;
    public state: string;
    public stateFullName: string;
    public name: string;
    public cityAndState: string;
    public isCurrent: boolean;
    public stateAbbr: string;

    constructor(location: ILocation = { city: "", state: "", key: "", cityAndState: " " } as ILocation) {
        this.key = location.key;
        this.orgKey = location.orgKey;
        this.cityKey = location.cityKey;
        this.city = !!location.city ? location.city : ' ';
        this.type = location.type;
        this.state = location.state;
        this.stateFullName = location.stateFullName;
        this.name = name;
        this.cityAndState = location.cityAndState;
        this.isCurrent = !!location.isCurrent;
        this.stateAbbr = location.stateAbbr;
    }
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/location.ts